import { LOGO_URL, LOGO_DARK_URL } from "@/lib/api";

export function Logo({ className = "h-12", variant = "light" }) {
  const src = variant === "dark" ? LOGO_DARK_URL : LOGO_URL;
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src={src} alt="GoStreet · Assistenza immediata dopo l'incidente"
        className="h-full w-auto object-contain" draggable="false" />
    </div>
  );
}

export function WordMark({ className = "text-2xl" }) {
  return (
    <span className={`gs-wordmark ${className}`}>
      <span className="go">Go</span>
      <span className="street">Street</span>
    </span>
  );
}
